module.exports = __webpack_public_path__ + "8b795ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/GreenCheckbox.png
// module id = 1960
// module chunks = 18 19 32 37